import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import ActionButton from './ActionButton';
import permissionsProvider from '../../../utilities/permissionsProvider';
import postData from '../../../utilities/postData';

const EditorSaveScheduleCancel = ({
    cancel,
    acl,
    save,
    reschedule,
    scheduleAction,
    appointmentId,
    appointmentType
}) => {
    const [alertMessage, setAlert] = useState({ warning: null, error: null });
    const [sendingEmail, setSendingEmail] = useState(false);

    const handleResult = (data) => {
        setSendingEmail(false);
        if (data && data.errors && (data.errors.warning || data.errors.error)) {
            setAlert(data.errors);
        } else {
            setAlert({ message: ['Email Sent'] });
            //trigger data changed event for change log
            window.dispatchEvent(new Event('updateChangeLog'));
        }
    }

    const resendEmail = () => {
        setSendingEmail(true);
        postData('/api/calendar/resendEmail',
            { appointmentType: appointmentType, appointmentId: appointmentId },
            handleResult);
    }

    return (<React.Fragment>
        {
            alertMessage.message &&
            <Row className="row justify-content-center">
                <Col>
                    <Alert variant="info" onClose={() => setAlert({ ...alertMessage, message: null })} dismissible>{alertMessage.message}</Alert>
                </Col>
            </Row>
        }
        {
            alertMessage.warning &&
            <Row className="row justify-content-center">
                <Col>
                    <Alert variant="warning" onClose={() => setAlert({ ...alertMessage, warning: null })} dismissible>{alertMessage.warning}</Alert>
                </Col>
            </Row>
        }
        {
            alertMessage.error &&
            <Row className="row justify-content-center">
                <Col>
                    <Alert variant="danger" onClose={() => setAlert({ ...alertMessage, error: null })} dismissible>{alertMessage.error}</Alert>
                </Col>
            </Row>
        }
        <Row className="justify-content-center">
            <Col className="d-flex justify-content-center">
                <ActionButton className="no-hide"
                    buttonText={reschedule ? 'Save' : 'Save and Schedule'}
                    imgSource="/images/check.svg"
                    onClick={save}
                    disabled={!permissionsProvider.canEdit(acl)} />
                {reschedule &&
                    <React.Fragment>
                        <ActionButton className="no-hide"
                            buttonText="Reschedule"
                            imgSource="/images/schedule.svg"
                            onClick={scheduleAction}
                            disabled={!permissionsProvider.canEdit(acl)} />
                        <ActionButton
                            disabled={sendingEmail}
                            className="no-hide"
                            buttonText="Resend Email"
                            imgSource="/images/email.svg"
                            onClick={resendEmail} />
                    </React.Fragment>
                }
                <ActionButton className="no-hide"
                    buttonText={!permissionsProvider.canEdit(acl) ? "Close" : "Cancel"}
                    imgSource="/images/cancel.svg"
                    onClick={cancel} />
            </Col>
        </Row>
    </React.Fragment>
    );
}

EditorSaveScheduleCancel.propTypes = {
    cancel: PropTypes.func.isRequired,
    save: PropTypes.func.isRequired
}

export default EditorSaveScheduleCancel;